import styled, { css } from 'styled-components'
import ControlSize, { controlBorderRadius, controlHeight } from '../../../types/control-size'
import ButtonComponent from '../button'
import IconButton from '../icon-button'

export const ArrowButton = styled(IconButton)`
    flex-shrink: 0;

    &:active {
        opacity: 1;
    }
`

export const Button = styled(ButtonComponent)`
    font-weight: normal;
    text-align: left;
    width: 100%;

    &:active {
        opacity: 1;
    }
`

export const Container = styled.div<{ controlColor: string; controlSize: ControlSize }>`
    display: flex;

    &:active {
        opacity: 0.8;
    }

    ${({ controlColor, controlSize }) => css`
        background: ${controlColor};
        border-radius: ${controlBorderRadius(controlSize)}px;
        min-height: ${controlHeight(controlSize)}px;
    `}
`
